// GoogleFormRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoogleFormRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.open(
      "https://forms.gle/P7B2NMVwGstAeVea8",
      "_blank",
      "noopener,noreferrer"
    );

    // Immediately send user back (prevents route loop)
    navigate(-1);
  }, [navigate]);

  return null;
};

export default GoogleFormRedirect;